import Print from '../../src/legacy/Print.tsx';
export default Print;
